export default "__VITE_PUBLIC_ASSET__89b0cc9e__"